const developmentConfig = {
  env: 'development',
  apiUrl: 'http://localhost',
  sentryDsn: null,
  clarityProjectId: '',
};

const puppeteerConfig = {
  env: 'development',
  apiUrl: 'http://nginx',
};

const stagingConfig = {
  env: 'staging',
  // staging API URL
  apiUrl: 'https://oneplan-api-staging.livingplans.africa',
  sentryDsn: null,
  clarityProjectId: '',
};

const productionConfig = {
  env: 'production',
  // production API URL
  apiUrl: 'https://oneplan-api.livingplans.africa',
  sentryDsn: 'https://070d2bd390ec2443490deaebfb996a60@o4509261195968512.ingest.de.sentry.io/4509910175711312',
  clarityProjectId: 't0upmwz63j',
};

let config;
// This check is crucial to prevent errors during SSG build where `window` is not available.
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  // production webapp URL
  if (hostname === 'oneplan.livingplans.africa') {
    config = productionConfig;
  // staging webapp URL
  } else if (hostname === 'oneplan-staging.livingplans.africa') {
    config = stagingConfig;
  } else if (hostname === 'localhost') {
    config = developmentConfig;
  } else if (navigator.webdriver) {
    config = puppeteerConfig;
  }

  else {
    config = developmentConfig;
  }
} else {
  config = stagingConfig;
}

export default config;
